import { ILGEChangeCouncil } from "../interfaces/ILGEChangeCouncil";
import { ILGEStaticCouncil } from "../interfaces/ILGEStaticCouncil";
import { LGElection } from "./LGElection";


export class LGCouncil {
    private readonly _lgeChangeCouncil: ILGEChangeCouncil | null;
    private readonly _lgeStaticCouncil: ILGEStaticCouncil;
    private readonly _nominationClose: Date | null;
  
    public selectedElection = 0;
    public elections: LGElection[] = [];
    constructor(
      lgeChangeCouncil: ILGEChangeCouncil | null,
      lgeStaticCouncil: ILGEStaticCouncil,
      nominationClose: Date | null
    ) {
        this._lgeChangeCouncil = lgeChangeCouncil;
        this._lgeStaticCouncil = lgeStaticCouncil;
        this._nominationClose = nominationClose;

        this._lgeStaticCouncil.elections.forEach(election => {
            // if (election.uid === 'elections/38f47fff-a54f-438b-a3ec-7ac0c8970d1e') {
            //     console.log('election', election);
            // }
        

            if (this._lgeChangeCouncil !== null) {
                const foundLGEChangeElection = this._lgeChangeCouncil?.elections.find(electionItem => electionItem !== null && electionItem.uid === election.uid);
                this.elections.push(new LGElection(foundLGEChangeElection ? foundLGEChangeElection : null, election));
            } else {
                this.elections.push(new LGElection(null, election));
            }
        });
    }

    get uid(): string {
        return this._lgeStaticCouncil.uid;
    }

    get councilName(): string {
        return this._lgeStaticCouncil.councilName;
    }  
    
    get councilFullName(): string {
        return this._lgeStaticCouncil.councilFullName;
    }
   
    get councilCode(): string {
        return this._lgeStaticCouncil.councilCode;
    }   

    get councilLogoURL(): string {
        return this._lgeStaticCouncil.councilLogoURL;
    }

    get electionStatus(): string {
        return this._lgeStaticCouncil.electionStatus;
    }

    get coucilLogoURL(): string {
        return `assets/logos/Logoc_${this._lgeStaticCouncil.councilCode}.png`;
    }

    get nominationsClose(): Date | null {
        return this._nominationClose;
    }

    
}